import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

import Dvr from "@material-ui/icons/Dvr";
import Close from "@material-ui/icons/Close";
import Info from "@material-ui/icons/Info";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import PropTypes from "prop-types";
import CustomInput from "components/CustomInput/CustomInput.js";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import SweetAlert from "react-bootstrap-sweetalert";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import stylesModal from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";

import axios from "axios";

import Loading from "components/loading.js";

axios.defaults.withCredentials = true;

const { REACT_APP_SERVER_URL } = process.env;

const stylesCard = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
};

const stylesList = {
  list: {
    display: "inline",
    padding: "5px",
  },
};

const alertOverrides = {
  marginTop: "-100px",
  marginRight: "0px",
  marginBottom: "0px",
  marginLeft: "0px",
};
const useStylesAlert = makeStyles(stylesAlert);

const useStylesModal = makeStyles(stylesModal);

const useStylesCard = makeStyles(stylesCard);

const useStylesList = makeStyles(stylesList);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function Projects(props) {
  const classesAlert = useStylesAlert();
  const classesModal = useStylesModal();
  const classesCard = useStylesCard();
  const classesList = useStylesList();

  const classes = {
    ...classesAlert,
    ...classesModal,
    ...classesCard,
    ...classesList,
  };

  const [id, setID] = React.useState("");
  const [email, setEmail] = React.useState(props.userInfo.email);
  const [emailState, setEmailState] = React.useState("");

  const [title, setTitle] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [pi, setPi] = React.useState("");

  const [pis, setPis] = React.useState([]);

  const [co_pi, setCo_pi] = React.useState("");

  const [co_pis, setCo_pis] = React.useState([]);

  const [pmid, setPmid] = React.useState("");
  //const [pmidState, setPmidState] = React.useState("");
  const [pmids, setPmids] = React.useState([]);
  const [pmidState, setPmidState] = React.useState("");

  const [pubs, setPubs] = React.useState([]);

  const [url, setUrl] = React.useState("");
  //const [pmidState, setPmidState] = React.useState("");
  const [urls, setUrls] = React.useState([]);
  const [urlState, setUrlState] = React.useState("");

  const [statusNumeric, setStatusNumeric] = React.useState("1");

  const [alert, setAlert] = React.useState(null);

  const [addProjectModal, setAddProjectModal] = React.useState(false);

  const [infoModal, setInfoModal] = React.useState(false);

  const [updateProjectModal, setUpdateProjectModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const verifyEmail = (email) => {
    const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(email)) {
      return true;
    }
    return false;
  };

  const verifyPmid = (num) => {
    const numRex = /^[0-9]+$/;

    const numDigits = num.toString().length;
    if (
      numRex.test(num) &&
      numDigits >= 1 &&
      numDigits <= 8 &&
      !pmids.includes(num)
    ) {
      return true;
    }

    return false;
  };

  const verifyUrl = (url) => {
    const urlRegex = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    if (urlRegex.test(url)) {
      return true;
    }
    return false;
  };

  const { userInfo } = props;
  const access = userInfo.access;

  const projectData = props.projects.map((prop) => {
    const editRights =
      (props.userInfo &&
        props.userInfo &&
        props.userInfo.email == prop.contact_email) ||
      (prop.pis && prop.pis.includes(props.userInfo.name)) ||
      (prop.co_pis && prop.co_pis.includes(props.userInfo.name)) ||
      access >= 5
        ? true
        : false;
    return {
      id: prop.id,
      email: prop.contact_email,
      title: prop.title,
      status: prop.status,

      actions: (
        // we've added some custom button actions
        <div className="actions-right">
          {/* use this button to add a like kind of action */}
          {/* use this button to add a edit kind of action */}
          <Button
            justIcon
            round
            simple
            onClick={() => {
              clearData();
              const findTitleIndex = ({ title }) => {
                return title == prop.title;
              };

              const titleIndex = props.projects.findIndex(findTitleIndex);

              const projectData = props.projects[titleIndex];

              projectData.statusNumeric =
                projectData.status == "analysis"
                  ? 3
                  : projectData.status == "completed"
                  ? 4
                  : 2;

              addData(projectData);
              setInfoModal(true);
            }}
            color="info"
            className="remove"
          >
            <Info />
          </Button>
          {editRights && (
            <Button
              justIcon
              round
              simple
              onClick={() => {
                clearData();
                const findTitleIndex = ({ title }) => {
                  return title == prop.title;
                };

                const titleIndex = props.projects.findIndex(findTitleIndex);

                const projectData = props.projects[titleIndex];

                addData(projectData);

                setUpdateProjectModal(true);
              }}
              color="warning"
              className="like"
            >
              <Dvr />
            </Button>
          )}
          {editRights && (
            <Button
              justIcon
              round
              simple
              onClick={() => {
                clearData();
                const findTitleIndex = ({ title }) => {
                  return title == prop.title;
                };

                const titleIndex = props.projects.findIndex(findTitleIndex);

                const projectData = props.projects[titleIndex];

                addData(projectData);

                confirmDeleteProject(prop.id, prop.title);
              }}
              color="danger"
              className="remove"
            >
              <Close />
            </Button>
          )}
        </div>
      ),
    };
  });

  const hideAlert = () => {
    setAlert(null);
  };

  const confirmDeleteProject = (id, title) => {
    setAlert(
      <SweetAlert
        warning
        style={alertOverrides}
        title="Are you sure?"
        onConfirm={() => handleDeleteProject(id)}
        onCancel={() => cancelDeleteProject(title)}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Yes, delete it!"
        cancelBtnText="Cancel"
        showCancel
      >
        {title} will be deleted!
      </SweetAlert>
    );
  };

  const cancelDeleteProject = (title) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title="Cancelled"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        {title} Not Deleted!
      </SweetAlert>
    );
  };

  const successAddProject = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => {
          hideAlert();
          setAddProjectModal(false);
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Project Added!
      </SweetAlert>
    );
  };

  const failAddProject = (errorMessage) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={errorMessage ? errorMessage : "Something Went Wrong!"}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        Project not added!
      </SweetAlert>
    );
  };

  const successDeleteProject = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        {title} Deleted!
      </SweetAlert>
    );
  };

  const failDeleteProject = (errorMessage) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={errorMessage ? errorMessage : "Something Went Wrong!"}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        {title} not Deleted!
      </SweetAlert>
    );
  };

  const successUpdateProject = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => {
          hideAlert();
          setUpdateProjectModal(false);
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        {title} has been updated!
      </SweetAlert>
    );
  };

  const failUpdateProject = (errorMessage) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={errorMessage ? errorMessage : "Something Went Wrong!"}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        {title} has NOT been updated!
      </SweetAlert>
    );
  };

  const confirmPub = (pub, pmid, pmids) => {
    setAlert(
      <SweetAlert
        warning
        style={alertOverrides}
        title={`Add ${pub.title} ?`}
        onConfirm={() => {
          handleAddElement(pmid, pmids, pub);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Add Publication"
        cancelBtnText="Cancel"
        showCancel
      >
        Add Publication
      </SweetAlert>
    );
  };

  const failAddPub = () => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={"Unable to find publication. Please check Pubmed ID."}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        Publication not added!
      </SweetAlert>
    );
  };

  const handleSubmitAddProject = async (e) => {
    e.preventDefault();

    const statusCode =
      statusNumeric == 3
        ? "analysis"
        : statusNumeric == 4
        ? "completed"
        : "ongoing";

    const postValues = {
      contact_email: props.userInfo.member ? props.userInfo.email : email,
      title: title,
      description: description,
      pis: pis,
      co_pis: co_pis,
      pmids: pmids,
      urls: urls,
      status: statusCode,
    };

    let addPubs;

    try {
      addPubs = await axios.post(
        `${REACT_APP_SERVER_URL}/studies`,
        {
          pubs,
        },
        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      addPubs = response;
      console.log(addPubs);
    }

    let updateProfile;
    /////NEED to change update profile route to see if project exists and if not create a new project.
    try {
      updateProfile = await axios.post(
        `${REACT_APP_SERVER_URL}/projects`,
        {
          ...postValues,
        },
        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      updateProfile = response;
    }
    if (updateProfile.status == 200 && addPubs.status == 200) {
      successAddProject();
      getProjects();
      getStudies();
    } else {
      failAddProject(updateProfile.data.messages.databaseError);
    }
  };

  const handleSubmitUpdateProject = async (e) => {
    e.preventDefault();

    const statusCode =
      statusNumeric == 3
        ? "analysis"
        : statusNumeric == 4
        ? "completed"
        : "ongoing";

    const postValues = {
      contact_email:
        props.userInfo.type == "member" ? props.userInfo.email : email,
      title: title,
      description: description,
      pis: pis,
      co_pis: co_pis,
      pmids: pmids,
      urls: urls,
      status: statusCode,
    };

    let addPubs;

    try {
      addPubs = await axios.post(
        `${REACT_APP_SERVER_URL}/studies`,
        {
          pubs,
        },
        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      addPubs = response;
      console.log(addPubs);
    }

    let updateProfile;
    /////NEED to change update profile route to see if project exists and if not create a new project.
    try {
      updateProfile = await axios.put(
        `${REACT_APP_SERVER_URL}/projects/${id}`,
        {
          ...postValues,
        },
        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      updateProfile = response;
    }

    if (updateProfile.status == 200 && addPubs.status == 200) {
      successUpdateProject();
      getProjects();
      getStudies();
    } else {
      failUpdateProject(updateProfile.data.messages.databaseError);
    }
  };

  async function getProjects() {
    props.reloadProjectsCallBack(true);
  }

  async function getStudies() {
    props.reloadStudiesCallBack(true);
  }

  const handleDeleteProject = async (id) => {
    const postValues = {
      id: id,
    };

    let deleteProject;

    try {
      deleteProject = await axios.delete(
        `${REACT_APP_SERVER_URL}/projects/${id}`,
        {
          ...postValues,
        },
        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      deleteProject = response;
    }
    if (deleteProject.status == 200) {
      successDeleteProject();
    } else {
      failDeleteProject(deleteProject.data.messages.databaseError);
    }

    props.reloadProjectsCallBack(true);
  };

  const addData = (projectData) => {
    projectData.id && setID(projectData.id);
    projectData.contact_email && setEmail(projectData.contact_email);
    projectData.title && setTitle(projectData.title);
    projectData.description && setDescription(projectData.description);
    projectData.pis && setPis(projectData.pis);
    projectData.co_pis && setCo_pis(projectData.co_pis);
    projectData.pmids && setPmids(projectData.pmids);
    projectData.urls && setUrls(projectData.urls);
    projectData.statusNumeric && setStatusNumeric(projectData.statusNumeric);
  };

  const clearData = () => {
    setID("");
    setEmail(props.userInfo.email);
    setEmailState(props.userInfo.email ? "success" : "");
    setTitle("");
    setDescription("");
    setPi("");
    setPis([]);
    setCo_pi("");
    setCo_pis([]);
    setPmid("");
    setPmids([]);
    setUrl("");
    setUrls([]);
    setPubs([]);
    setStatusNumeric("1");
  };

  const handleAddElement = (element, elementList, pub) => {
    const elementListNew = elementList.filter(
      (element) => typeof element !== "undefined"
    );

    element != "" && elementListNew.push(element);

    if (elementList == co_pis) {
      setCo_pis(elementListNew);
      setCo_pi("");
    }

    if (elementList == pis) {
      setPis(elementListNew);
      setPi("");
    }

    if (elementList == pmids) {
      setPmids(elementListNew);
      setPmid("");
    }

    if (elementList == urls) {
      setUrls(elementListNew);
      setUrl("");
    }

    if (pub) {
      pubs.push(pub);
    }
  };

  const handleRemoveElement = (element, elementList, pub) => {
    const elementListFiltered = elementList.filter((e) => e !== element);

    if (pub) {
      const pubsFiltered = pubs.filter((pubItem) => {
        return pubItem.uid != element;
      });

      setPubs(pubsFiltered);
    }

    if (elementList == co_pis) {
      setCo_pis(elementListFiltered);
      setCo_pi("");
    }
    if (elementList == pis) {
      setPis(elementListFiltered);
      setPi("");
    }
    if (elementList == pmids) {
      setPmids(elementListFiltered);
      setPmid("");
    }
    if (elementList == urls) {
      setUrls(elementListFiltered);
      setUrl("");
    }
  };

  const getPubmedDetails = async (pmid, pmids) => {
    setLoading(true);
    let details;
    /////NEED to change update profile route to see if project exists and if not create a new project.
    try {
      details = await axios.get(
        `${REACT_APP_SERVER_URL}/pubmed/${pmid}`,

        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      details = response;
    }
    setLoading(false);

    if (
      details.data &&
      details.data.info &&
      Object.keys(details.data.info).length > 1
    ) {
      confirmPub(details.data.info, pmid, pmids);
      return details.data.info;
    }
    console.log("Error");

    failAddPub();
    return "Error";
  };

  const projectStudies = props.studies.filter((study) => {
    return pmids.includes(study.uid);
  });

  return (
    <div>
      {alert}

      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={addProjectModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setAddProjectModal(false)}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <DialogTitle
          id="notice-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => {
              clearData();
              setAddProjectModal(false);
            }}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>Add Project</h4>
        </DialogTitle>
        <DialogContent
          id="notice-modal-slide-description"
          className={classes.modalBody}
        >
          <div className={classes.modalBody}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <form onSubmit={handleSubmitAddProject}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Project Title *"
                        id="title"
                        success={title.length > 0}
                        error={!title.length > 0}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: title,
                          onChange: (event) => {
                            setTitle(event.target.value);
                          },
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        success={emailState === "success"}
                        error={emailState === "error"}
                        labelText="Contact Email *"
                        id="email"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: email,
                          onChange: (event) => {
                            if (verifyEmail(event.target.value)) {
                              setEmailState("success");
                            } else {
                              setEmailState("error");
                            }
                            setEmail(event.target.value);
                          },
                          type: "email",
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Principal Investigator Name"
                        id="pi"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: pi,
                          onChange: (event) => {
                            setPi(event.target.value);
                          },
                        }}
                      />
                      <Button
                        color="info"
                        className={classes.updateProfileButton}
                        onClick={() => {
                          handleAddElement(pi, pis);
                        }}
                        disabled={pi.length > 0 ? false : true}
                      >
                        Add Principal Investigator
                      </Button>
                      <br />
                      {pis &&
                        pis.map((pi) => (
                          <li className={classes.list} key={pi}>
                            {pi}
                            <Button
                              justIcon
                              round
                              simple
                              onClick={() => {
                                handleRemoveElement(pi, pis);
                              }}
                              color="danger"
                              className="remove"
                            >
                              <Close />
                            </Button>
                          </li>
                        ))}
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Co-Investigator Name"
                        id="co_pi"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: co_pi,
                          onChange: (event) => {
                            setCo_pi(event.target.value);
                          },
                        }}
                      />
                      <Button
                        color="info"
                        className={classes.updateProfileButton}
                        onClick={() => {
                          handleAddElement(co_pi, co_pis);
                        }}
                        disabled={co_pi.length > 0 ? false : true}
                      >
                        Add Co-Investigator
                      </Button>
                      <br />
                      {co_pis &&
                        co_pis.map((co_pi) => (
                          <li className={classes.list} key={co_pi}>
                            {co_pi}
                            <Button
                              justIcon
                              round
                              simple
                              onClick={() => {
                                handleRemoveElement(co_pi, co_pis);
                              }}
                              color="danger"
                              className="remove"
                            >
                              <Close />
                            </Button>
                          </li>
                        ))}
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        success={pmidState === "success"}
                        error={pmidState === "error"}
                        labelText="Pubmed ID Associated With Project"
                        id="pmid"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: pmid,
                          onChange: (event) => {
                            if (verifyPmid(event.target.value)) {
                              setPmidState("success");
                            } else {
                              setPmidState("error");
                            }
                            setPmid(event.target.value);
                          },
                          type: "number",
                        }}
                      />
                      {loading && <Loading />}
                      <Button
                        color="info"
                        className={classes.updateProfileButton}
                        onClick={() => {
                          getPubmedDetails(pmid, pmids);
                        }}
                        disabled={
                          pmid.length > 0 && pmidState == "success"
                            ? false
                            : true
                        }
                      >
                        Add Pubmed ID
                      </Button>
                      <br />
                      {pmids &&
                        pmids.map((pmid) => (
                          <li className={classes.list} key={pmid}>
                            {pmid}
                            <Button
                              justIcon
                              round
                              simple
                              onClick={() => {
                                handleRemoveElement(pmid, pmids, true);
                              }}
                              color="danger"
                              className="remove"
                            >
                              <Close />
                            </Button>
                          </li>
                        ))}
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        success={urlState === "success"}
                        error={urlState === "error"}
                        labelText="Additional URL Associated With Project"
                        id="url"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: url,
                          onChange: (event) => {
                            if (verifyUrl(event.target.value)) {
                              setUrlState("success");
                            } else {
                              setUrlState("error");
                            }
                            setUrl(event.target.value);
                          },
                          type: "url",
                        }}
                      />
                      <Button
                        color="info"
                        className={classes.updateProfileButton}
                        onClick={() => {
                          handleAddElement(url, urls);
                        }}
                        disabled={
                          url.length > 0 && urlState == "success" ? false : true
                        }
                      >
                        Add URL
                      </Button>
                      <br />
                      {urls &&
                        urls.map((url) => (
                          <li className={classes.list} key={url}>
                            {url}
                            <Button
                              justIcon
                              round
                              simple
                              onClick={() => {
                                handleRemoveElement(url, urls);
                              }}
                              color="danger"
                              className="remove"
                            >
                              <Close />
                            </Button>
                          </li>
                        ))}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classes.selectLabel}
                        >
                          Select Project Status
                        </InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu,
                          }}
                          classes={{
                            select: classes.select,
                          }}
                          inputProps={{
                            name: "simpleSelect",
                            id: "statusNumeric",
                            value: statusNumeric,
                            onChange: (event) => {
                              setStatusNumeric(event.target.value);
                            },
                          }}
                        >
                          <MenuItem
                            disabled
                            classes={{
                              root: classes.selectMenuItem,
                            }}
                          >
                            Select Type
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="2"
                          >
                            Ongoing
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="3"
                          >
                            Analysis
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="4"
                          >
                            Completed
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText={"Description (Max Characters: 1000)"}
                        id="description"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: description,
                          onChange: (event) => {
                            setDescription(event.target.value);
                          },
                          multiline: true,
                          rows: 5,
                          maxLength: 1000,
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <Button
                    color="info"
                    className={classes.updateProfileButton}
                    type="submit"
                    disabled={
                      !(
                        emailState == "success" &&
                        email.length > 0 &&
                        title.length > 0
                      )
                    }
                  >
                    Submit Project
                  </Button>
                </form>
              </GridItem>
            </GridContainer>
          </div>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button
            onClick={() => {
              setAddProjectModal(false);
            }}
            color="rose"
            round
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={infoModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setInfoModal(false)}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <DialogTitle
          id="notice-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setInfoModal(false)}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>{title}</h4>
        </DialogTitle>
        <DialogContent
          id="notice-modal-slide-description"
          className={classes.modalBody}
        >
          <div className={classes.modalBody}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                {description && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Description</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <p>{description}</p>
                    </GridItem>
                  </GridContainer>
                )}

                {pis && pis.length > 0 && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Principal investigators</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      {pis &&
                        pis.map((pi) => (
                          <li className={classes.list} key={pi}>
                            {pi}
                          </li>
                        ))}
                    </GridItem>
                  </GridContainer>
                )}

                {co_pis && co_pis.length > 0 && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Co-investigators</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      {co_pis &&
                        co_pis.map((co_pi) => (
                          <li className={classes.list} key={co_pi}>
                            {co_pi}
                          </li>
                        ))}
                    </GridItem>
                  </GridContainer>
                )}

                {email && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Contact email</b>
                      </h4>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <p>{email}</p>
                    </GridItem>
                  </GridContainer>
                )}
                {projectStudies.length > 0 && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h4 className={classes.cardTitle}>
                        <b>Project Publications</b>
                      </h4>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      {projectStudies &&
                        projectStudies.map((study) => (
                          <li key={study}>
                            <a
                              href={
                                "https://pubmed.ncbi.nlm.nih.gov/" + study.uid
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {study.title}
                            </a>
                          </li>
                        ))}
                      {urls &&
                        urls.map((url) => (
                          <li key={url}>
                            <a
                              href={"//" + url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {url}
                            </a>
                          </li>
                        ))}
                    </GridItem>
                  </GridContainer>
                )}
              </GridItem>
            </GridContainer>
          </div>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button onClick={() => setInfoModal(false)} color="rose" round>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={updateProjectModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setUpdateProjectModal(false)}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <DialogTitle
          id="notice-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => {
              clearData();
              setUpdateProjectModal(false);
            }}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>{title}</h4>
        </DialogTitle>
        <DialogContent
          id="notice-modal-slide-description"
          className={classes.modalBody}
        >
          <div className={classes.modalBody}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <form onSubmit={handleSubmitUpdateProject}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Project Title *"
                        id="title"
                        success={title.length > 0}
                        error={!title.length > 0}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: title,
                          onChange: (event) => {
                            setTitle(event.target.value);
                          },
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        success={emailState === "success"}
                        error={emailState === "error"}
                        labelText="Contact Email *"
                        id="email"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          onChange: (event) => {
                            if (verifyEmail(event.target.value)) {
                              setEmailState("success");
                            } else {
                              setEmailState("error");
                            }
                            setEmail(event.target.value);
                          },
                          type: "email",
                          value: email,
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Principal Investigator Name"
                        id="pi"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: pi,
                          onChange: (event) => {
                            setPi(event.target.value);
                          },
                        }}
                      />
                      <Button
                        color="info"
                        className={classes.updateProfileButton}
                        onClick={() => {
                          handleAddElement(pi, pis);
                        }}
                        disabled={pi.length > 0 ? false : true}
                      >
                        Add Principal Investigator
                      </Button>
                      <br />
                      {pis &&
                        pis.map((pi) => (
                          <li className={classes.list} key={pi}>
                            {pi}
                            <Button
                              justIcon
                              round
                              simple
                              onClick={() => {
                                handleRemoveElement(pi, pis);
                              }}
                              color="danger"
                              className="remove"
                            >
                              <Close />
                            </Button>
                          </li>
                        ))}
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Co-Investigator Name"
                        id="co_pi"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: co_pi,
                          onChange: (event) => {
                            setCo_pi(event.target.value);
                          },
                        }}
                      />
                      <Button
                        color="info"
                        className={classes.updateProfileButton}
                        onClick={() => {
                          handleAddElement(co_pi, co_pis);
                        }}
                        disabled={co_pi.length > 0 ? false : true}
                      >
                        Add Co-Investigator
                      </Button>
                      <br />
                      {co_pis &&
                        co_pis.map((co_pi) => (
                          <li className={classes.list} key={co_pi}>
                            {co_pi}
                            <Button
                              justIcon
                              round
                              simple
                              onClick={() => {
                                handleRemoveElement(co_pi, co_pis);
                              }}
                              color="danger"
                              className="remove"
                            >
                              <Close />
                            </Button>
                          </li>
                        ))}
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        success={pmidState === "success"}
                        error={pmidState === "error"}
                        labelText="Pubmed ID Associated With Project"
                        id="pmid"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: pmid,
                          onChange: (event) => {
                            if (verifyPmid(event.target.value)) {
                              setPmidState("success");
                            } else {
                              setPmidState("error");
                            }
                            setPmid(event.target.value);
                          },
                          type: "number",
                        }}
                      />
                      {loading && <Loading />}
                      <Button
                        color="info"
                        className={classes.updateProfileButton}
                        onClick={() => {
                          getPubmedDetails(pmid, pmids);
                        }}
                        disabled={
                          pmid.length > 0 && pmidState == "success"
                            ? false
                            : true
                        }
                      >
                        Add Pubmed ID
                      </Button>
                      <br />
                      {pmids &&
                        pmids.map((pmid) => (
                          <li className={classes.list} key={pmid}>
                            {pmid}
                            <Button
                              justIcon
                              round
                              simple
                              onClick={() => {
                                handleRemoveElement(pmid, pmids, true);
                              }}
                              color="danger"
                              className="remove"
                            >
                              <Close />
                            </Button>
                          </li>
                        ))}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        success={urlState === "success"}
                        error={urlState === "error"}
                        labelText="Additional URL Associated With Project"
                        id="url"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: url,
                          onChange: (event) => {
                            if (verifyUrl(event.target.value)) {
                              setUrlState("success");
                            } else {
                              setUrlState("error");
                            }
                            setUrl(event.target.value);
                          },
                          type: "url",
                        }}
                      />
                      <Button
                        color="info"
                        className={classes.updateProfileButton}
                        onClick={() => {
                          handleAddElement(url, urls);
                        }}
                        disabled={
                          url.length > 0 && urlState == "success" ? false : true
                        }
                      >
                        Add URL
                      </Button>
                      <br />
                      {urls &&
                        urls.map((url) => (
                          <li className={classes.list} key={url}>
                            {url}
                            <Button
                              justIcon
                              round
                              simple
                              onClick={() => {
                                handleRemoveElement(url, urls);
                              }}
                              color="danger"
                              className="remove"
                            >
                              <Close />
                            </Button>
                          </li>
                        ))}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classes.selectLabel}
                        >
                          Select Project Status
                        </InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu,
                          }}
                          classes={{
                            select: classes.select,
                          }}
                          inputProps={{
                            name: "simpleSelect",
                            id: "statusNumeric",
                            value: statusNumeric,
                            onChange: (event) => {
                              setStatusNumeric(event.target.value);
                            },
                          }}
                        >
                          <MenuItem
                            disabled
                            classes={{
                              root: classes.selectMenuItem,
                            }}
                          >
                            Select Type
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="2"
                          >
                            Ongoing
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="3"
                          >
                            Analysis
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="4"
                          >
                            Completed
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText={"Description (Max Characters: 1000)"}
                        id="description"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          multiline: true,
                          rows: 5,
                          maxLength: 1000,
                          value: description,
                          onChange: (event) => {
                            setDescription(event.target.value);
                          },
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <Button
                    color="info"
                    className={classes.updateProfileButton}
                    type="submit"
                    disabled={
                      !(
                        emailState == "success" &&
                        email.length > 0 &&
                        title.length > 0
                      )
                    }
                  >
                    Update Project
                  </Button>
                </form>
              </GridItem>
            </GridContainer>
          </div>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button
            onClick={() => setUpdateProjectModal(false)}
            color="rose"
            round
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              {access >= 4 && (
                <Button
                  color="info"
                  className={classes.updateProfileButton}
                  onClick={() => {
                    clearData();
                    setAddProjectModal(true);
                  }}
                >
                  Add Project
                </Button>
              )}

              <ReactTable
                columns={[
                  {
                    Header: "Title",
                    accessor: "title",
                  },

                  {
                    Header: "Status",
                    accessor: "status",
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                  },
                ]}
                initialState={{ hiddenColumns: ["type"] }}
                data={projectData}
                defaultPageSize={20}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

Projects.propTypes = {
  studies: PropTypes.array,
  projects: PropTypes.array,
  users: PropTypes.array,
  userInfo: PropTypes.object,
  reloadProjectsCallBack: PropTypes.func,
  reloadStudiesCallBack: PropTypes.func,
};
